import request from '@/utils/request'
import host from '@/api/base/host'
const mini = host.path('dev', { module: 'mini', dev: 'v1' })
console.log(process.env.NODE_ENV, 'process.env.NODE_ENV')

const isTestEnv =
  process.env.NODE_ENV !== 'production' ||
  location.href.indexOf('ylyk-test.com') > 0 ||
  location.href.indexOf('ylyk.com/test/') > 0

const requestUrl = isTestEnv ? 'https://manage-tylsn-test.ylyk.com' : 'https://manage-tylsn.ylyk.com'

export const appUserForeverInfo = data => {
  return request({
    url: mini('order/getUserForeverOrder'),
    method: 'post',
    data
  })
}

//
export const userForeverInfo = data => {
  return request({
    url: requestUrl + '/v1/order/userForeverInfo',
    method: 'post',
    data
  })
}
export const getWXconfig = data => {
  return request({
    url: requestUrl + '/sys/qyWxJsapiSignature',
    method: 'post',
    data
  })
}
export const getUserAuth = data => {
  return request({
    url: requestUrl + '/sys/weOAuth2',
    method: 'post',
    data,
    params: data
  })
}

export const setVip2SVip = data => {
  return request({
    url: requestUrl + '/v1/wecom/tag/vip2SVip',
    method: 'get',
    params: data
  })
}
